import * as CONST from './const'

/**
 * Open the main side bar
 */
export const openMainSidebar = function() {
  return {
    type: CONST.OPEN_MAIN_SIDE_BAR,
  }
}

/**
 * Close the main side bar
 */
export const closeMainSidebar = function() {
  return {
    type: CONST.CLOSE_MAIN_SIDE_BAR,
  }
}

/**
 * Update a filter's value in app state
 * @param {string} filterGroup
 * @param {string} name
 * @param {string} value
 */
export const updateFilterValue = function(filterGroup, name, value) {
  return {
    type: CONST.UPDATE_FILTER_VALUE,
    payload: {
      filterGroup,
      name,
      value,
    },
  }
}

/**
 * Show the unbook modal
 */
export const showUnbookModal = payload => {
  return {
    type: CONST.SHOW_UNBOOK_MODAL,
    payload,
  }
}
/**
 * Select change
 */
export const unbookModalChange = payload => {
  return {
    type: CONST.UNBOOK_MODAL_CHANGE,
    payload,
  }
}
/**
 * Hide the unbook modal
 */
export const hideUnbookModal = () => {
  return {
    type: CONST.HIDE_UNBOOK_MODAL,
  }
}

/**
 * Show the redux modal
 */
export const showReduxModal = payload => {
  return {
    type: CONST.SHOW_REDUX_MODAL,
    payload,
  }
}

/**
 * Hide the redux modal
 */
export const hideReduxModal = () => {
  return {
    type: CONST.HIDE_REDUX_MODAL,
  }
}

/**
 * Resets the redux modal
 */
export const resetReduxModal = () => {
  return {
    type: CONST.RESET_REDUX_MODAL,
  }
}

/**
 * Toggles availability of the confirm button on the redux modal
 */
export const toggleConfirmAvailabilityReduxModal = () => {
  return {
    type: CONST.TOGGLE_CONFIRM_AVAILABILITY_REDUX_MODAL,
  }
}
